import React from "react";
import { motion } from "framer-motion";

const PolicyLayout = ({ title, children }) => {
  return (
    <div className="bg-white min-h-screen pt-10 pb-20">
      <div className="max-w-4xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="text-4xl md:text-5xl font-black text-gray-dark mb-8 tracking-tight">
            {title}
          </h1>
          <div className="prose prose-orange max-w-none text-gray-600 leading-relaxed space-y-6 font-medium">
            {children}
          </div>
        </motion.div>
      </div>
    </div>
  );
};

const Disclaimer = () => {
  return (
    <PolicyLayout title="Disclaimer">
      <section>
        <h2 className="text-2xl font-bold text-gray-dark mt-8 mb-4">1. General Information</h2>
        <p>The information provided by Khajuraho Routes is for general informational purposes only. While we strive to provide accurate details about Khajuraho Routess, local events, and travel costs, all information on the site is provided in good faith and is subject to change without notice.</p>
      </section>
      <section>
        <h2 className="text-2xl font-bold text-gray-dark mt-8 mb-4">2. Tour Itineraries</h2>
        <p>Tour itineraries are suggestive and may be modified due to local conditions, monument timings, weather, or other logistics. We reserve the right to change the sequence of sightseeing or substitute hotels with similar standards if necessary.</p>
      </section>
      <section>
        <h2 className="text-2xl font-bold text-gray-dark mt-8 mb-4">3. Availability</h2>
        <p>Bookings for specific services like the Khajuraho Light and Sound Show or Panna Tiger Reserve safaris are subject to availability and government regulations. We act as facilitators and are not responsible for cancellations by government bodies.</p>
      </section>
      <section>
        <h2 className="text-2xl font-bold text-gray-dark mt-8 mb-4">4. Personal Safety</h2>
        <p>Travelers are responsible for their own personal belongings and safety during the tour. We recommend following all local guidelines and temple protocols during your visit to Khajuraho.</p>
      </section>
    </PolicyLayout>
  );
};

export default Disclaimer;
